export default __webpack_public_path__ + "static/Footer_background-cae4ce4730c6926d08b14d1a8704e060.svg";